import type { Post as PostGridPost } from '../types/posts';
import type { Post as SharedPost } from '../types/shared';

/**
 * Maps an array of shared Post objects to PostGridPost[] for use in PostGrid.
 * Ensures all required fields are populated or defaulted to prevent runtime errors.
 *
 * @param posts - Array of shared Post objects
 * @returns Array of PostGridPost objects
 */
export function mapPostsToGridFormat(posts: SharedPost[]): PostGridPost[] {
    return posts.map((post) => ({
        id: post.id,
        title: post.title,
        featuredImage: post.featuredImage ?? null,
        primaryCategory: post.primaryCategory ?? post.categories?.[0] ?? null,
        categories: post.categories ?? [],
        link: post.link,
    }));
}
